// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { getOr } from "lodash/fp";
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';

const {GRID_STYLES, FIELD_CONTAINER_TYPES, CONDITION_TYPE, DATA_TYPE} = constants;

const getConditionField = (element, containerType) => {
  const name = getOr('', 'field.fieldNameAlias', element);
  const type = getOr('', 'field.dataFieldType', element);
  const dateTimeFormatData = getOr('', 'dateTimeFormatData', element);
  const previewDataType = getOr('', 'previewDataType', element);
  return {
    name: name,
    value: {
      type: type,
      dateTimeFormatData: dateTimeFormatData,
      previewDataType: previewDataType,
      containerType: containerType
    }
  }
};

const getGridProperties = (reportPartContent) => {
  const gridStyle = reportPartContent.gridStyle;
  const useSideTotal = getOr(false, 'columns.properties.addSideTotal', reportPartContent);

  return {
    gridStyle,
    useSideTotal
  };
}

const groupReportPartElements = (reportPartContent) => {
  const {gridStyle, useSideTotal} = getGridProperties(reportPartContent);
  const simpleFields = [];
  const additionalFields = [];

  if(gridStyle === GRID_STYLES.VERTICAL){
    reportPartContent.columns.elements.forEach(element => { simpleFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.COLUMN)) });
  }else if(gridStyle === GRID_STYLES.HORIZONTAL){
    reportPartContent.rows.elements.forEach(element => { simpleFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.ROW)) });
  }else if(gridStyle === GRID_STYLES.PIVOT){
    reportPartContent.rows.elements.forEach(element => { simpleFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.ROW)) });
    reportPartContent.values.elements.forEach(element => { simpleFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.VALUE)) });
    reportPartContent.columns.elements.forEach(element => { additionalFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.COLUMN)) });
  }else if(gridStyle === GRID_STYLES.DRILL_DOWN){
    reportPartContent.rows.elements.forEach(element => { simpleFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.COLUMN)) });
    reportPartContent.values.elements.forEach(element => { simpleFields.push(getConditionField(element, FIELD_CONTAINER_TYPES.VALUE)) });
  }

  return {
    simpleFields,
    additionalFields
  };
}

const getConditionTypesByFieldType = (conditionFieldDataType, isAdditionalCondition) => {
  const conditionTypes = [];
  switch(conditionFieldDataType){
    default:
    case DATA_TYPE.MONEY:
    case DATA_TYPE.NUMERIC:
      conditionTypes.push(CONDITION_TYPE.VALUE);
      conditionTypes.push(CONDITION_TYPE.RANGE_VALUE);
      if(!isAdditionalCondition)
        conditionTypes.push(CONDITION_TYPE.RANGE_PERCENT);
      conditionTypes.push(CONDITION_TYPE.ALL_VALUES);
      break;
    case DATA_TYPE.DATETIME:
    case DATA_TYPE.TIME:
      conditionTypes.push(CONDITION_TYPE.VALUE);
      conditionTypes.push(CONDITION_TYPE.RANGE_VALUE);
      conditionTypes.push(CONDITION_TYPE.ALL_VALUES);
      break;
    case DATA_TYPE.TEXT:
    case DATA_TYPE.BOOLEAN:
      conditionTypes.push(CONDITION_TYPE.VALUE);
      conditionTypes.push(CONDITION_TYPE.ALL_VALUES);
      break;
  }
  return conditionTypes;
}

export default {
  getConditionField: getConditionField,
  groupReportPartElements: groupReportPartElements,
  getConditionTypesByFieldType: getConditionTypesByFieldType,
  getGridProperties: getGridProperties
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingUtils.js